import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/** The server answers the same shape for `GET …/transcript` and `POST …/transcriptions`. */
export type TranscriptPayload = {
	readonly id: number;
	readonly interview: { readonly id: number };
	readonly facility: { readonly id: number };
	readonly engineFamily: LabeledValuePayload | null;
	readonly turnCount: number;
	readonly hasSpeakers: boolean;
	readonly reviewedAt: string | null;
	// `{ id }`, never a resolved name: this screen has no user collection loaded to resolve it against.
	readonly reviewedBy: { readonly id: number } | null;
	readonly revisedTurnCount: number;
};

export type TranscriptFetchedAction = {
	type: 'TRANSCRIPT_FETCHED';
	payload: TranscriptPayload;
	facilityId: number;
	subjectId: number;
	interviewId: number;
};

export default (
	payload: TranscriptPayload,
	facilityId: number,
	subjectId: number,
	interviewId: number,
): TranscriptFetchedAction => ({
	type: 'TRANSCRIPT_FETCHED',
	payload,
	facilityId,
	subjectId,
	interviewId,
});
